import { buildPath, toURLFriendlyStringWithDashes } from '../navigation/destinations';

export { toURLFriendlyStringWithDashes };

export function formatExternalLink(url: string) {
  if (!url) {
    return '';
  }
  return url.startsWith('http') ? url : `//${url}`;
}

/** The company profile's default page; `buildPath('company.<tab>', ...)` for one of its tabs. */
export function getCompanyProfileUrl(name: string, id: number) {
  return buildPath('company', { companyId: id }, name);
}
